// extracted by mini-css-extract-plugin
export default {"AppArticleTitle":"AppArticleTitle_AppArticleTitle__+3MYc"};